// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_af684b05","prominentTile":"_563db5fa","sideTile":"_126f7479"};